module.exports = __webpack_public_path__ + "img/icons.f0802743.svg";